import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import VueCollapsiblePanel from '@dafcoe/vue-collapsible-panel'
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'



createApp(App).use(router).use(VueCollapsiblePanel).mount('#app')

